"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const makeButtons = ({
  palette
}) => ({
  palette: {
    button: {
      contained: {
        base: {
          mobile: {
            fontSize: '1rem'
          },
          desktop: {
            fontSize: '1.33em'
          }
        },
        primary: {
          color: palette.primary.contrastText,
          background: palette.primary.main,
          borderColor: palette.primary.main,
          hover: {
            color: palette.primary.contrastText,
            background: palette.background.primary.dark,
            borderColor: palette.site.contrastText
          },
          focus: {
            color: palette.primary.contrastText,
            background: palette.background.primary.dark,
            borderColor: palette.site.contrastText
          }
        },
        secondary: {
          color: palette.secondary.contrastText,
          background: palette.secondary.main,
          borderColor: palette.secondary.border,
          hover: {
            color: palette.secondary.contrastText,
            background: palette.secondary.light,
            borderColor: palette.secondary.border
          },
          focus: {
            color: palette.secondary.contrastText,
            background: palette.secondary.light,
            borderColor: palette.secondary.border
          }
        },
        tertiary: {
          color: palette.tertiary.contrastText,
          background: palette.tertiary.main,
          borderColor: palette.tertiary.contrastText,
          hover: {
            color: palette.tertiary.contrastText,
            background: palette.tertiary.light,
            borderColor: palette.tertiary.contrastText
          },
          focus: {
            color: palette.tertiary.contrastText,
            background: palette.tertiary.light,
            borderColor: palette.tertiary.contrastText
          }
        },
        quaternary: {
          color: palette.quaternary.contrastText,
          background: palette.quaternary.main,
          borderColor: palette.quaternary.main,
          hover: {
            color: palette.quaternary.contrastText,
            background: palette.quaternary.light,
            borderColor: palette.quaternary.light
          },
          focus: {
            color: palette.quaternary.contrastText,
            background: palette.quaternary.light,
            borderColor: palette.quaternary.light
          }
        }
      },
      outline: {
        base: {
          mobile: {
            fontSize: '1rem'
          },
          desktop: {
            fontSize: '1.33em'
          }
        },
        primary: {
          color: palette.primary.main,
          background: "transparent",
          borderColor: palette.primary.main,
          hover: {
            color: palette.primary.light,
            background: "transparent",
            borderColor: palette.primary.light
          },
          focus: {
            color: palette.primary.light,
            background: "transparent",
            borderColor: palette.primary.light
          }
        },
        secondary: {
          color: palette.secondary.main,
          background: "transparent",
          borderColor: palette.secondary.main,
          hover: {
            color: palette.secondary.light,
            background: "transparent",
            borderColor: palette.secondary.light
          },
          focus: {
            color: palette.secondary.light,
            background: "transparent",
            borderColor: palette.secondary.light
          }
        },
        tertiary: {
          color: palette.primary.main,
          background: "transparent",
          borderColor: palette.primary.main,
          hover: {
            color: palette.primary.light,
            background: "transparent",
            borderColor: palette.primary.light
          },
          focus: {
            color: palette.primary.light,
            background: "transparent",
            borderColor: palette.primary.light
          }
        }
      },
      text: {
        base: {
          mobile: {
            fontSize: '1rem'
          },
          desktop: {
            fontSize: '1rem'
          }
        },
        primary: {
          color: palette.primary.main,
          background: "transparent",
          hover: {
            color: palette.primary.main,
            background: "transparent"
          },
          focus: {
            color: palette.primary.main,
            background: "transparent"
          }
        },
        secondary: {
          color: palette.secondary.main,
          background: "transparent",
          hover: {
            color: palette.secondary.main,
            background: "transparent"
          },
          focus: {
            color: palette.secondary.main,
            background: "transparent"
          }
        },
        tertiary: {
          color: palette.tertiary.main,
          background: "transparent",
          hover: {
            color: palette.tertiary.main,
            background: "transparent"
          },
          focus: {
            color: palette.tertiary.main,
            background: "transparent"
          }
        }
      }
    }
  }
});
var _default = exports.default = makeButtons;